import React, { memo, useMemo, useCallback } from 'react';
import { FieldsFormType } from './EditMyScheduleModal';
import { FormSelect, FormInput, FormCheckbox } from '@core/components/form';
import { Button, Col, Row } from 'reactstrap';
import { formGroup, formControl } from '@core/utils/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useDidMount } from '@core/utils/hooks/react';

export interface FieldItemProps {
  form: FieldsFormType;
  onRemove: () => void;
}

export const FieldItem = memo((props: FieldItemProps) => {
  const { form, onRemove } = props;
  const formValue = useNonNilObservable(form.value$);

  return (
    <div className="border-bottom pb-4 mb-4">
      <Row>
        <Col>
          <FormSelect
            control={form.controls.type}
            items={[
              { label: 'Single Line Text', value: 'text' },
              { label: 'Paragraph', value: 'multi_line_text' },
              { label: 'Email', value: 'email' },
              { label: 'Phone', value: 'phone' },
              { label: 'Checkbox', value: 'checkbox' },
              { label: 'Date', value: 'date' },
            ]}
          />
        </Col>
        <Col>
          <FormInput control={form.controls.label} />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormCheckbox control={form.controls.required} />
        </Col>
      </Row>
      <Button onClick={() => onRemove()} color="danger">
        <i className="fas fa-trash-alt "></i>
      </Button>
    </div>
  );
});
